/**
 * @generated SignedSource<<e652874733c968c47b007339e44eb2c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteWebhookSubscriptionInput = {
  id: any;
};
export type FireHydrantIntegrationDeleteWebhookSubscriptionMutation$variables = {
  input: DeleteWebhookSubscriptionInput;
};
export type FireHydrantIntegrationDeleteWebhookSubscriptionMutation$data = {
  readonly deleteWebhookSubscription: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type FireHydrantIntegrationDeleteWebhookSubscriptionMutation = {
  response: FireHydrantIntegrationDeleteWebhookSubscriptionMutation$data;
  variables: FireHydrantIntegrationDeleteWebhookSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteWebhookSubscriptionPayload",
    "kind": "LinkedField",
    "name": "deleteWebhookSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FireHydrantIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FireHydrantIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3d0491148656fa176a01d62148839c86",
    "id": null,
    "metadata": {},
    "name": "FireHydrantIntegrationDeleteWebhookSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation FireHydrantIntegrationDeleteWebhookSubscriptionMutation(\n  $input: DeleteWebhookSubscriptionInput!\n) {\n  deleteWebhookSubscription(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "179fa569b7c8284bd6e7e62a003c65a0";

export default node;
